// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__yQH-w","savePackageButton":"ClientWallet_savePackageButton__3b2tk"};